export const Pause = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M16.875 21.5625H20.625V8.4375H16.875M9.375 21.5625H13.125V8.4375H9.375V21.5625Z"
        fill="black"
      />
    </svg>
  );
};
